module.exports = __webpack_public_path__ + "static/media/devices.913ca1a0.svg";